import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

const galleries = document.querySelectorAll('.photo-gallery');

galleries.forEach((galleryItem, index) => {

    galleryItem.classList.add(`photo-gallery-${index}`);

    let galleryContainer = $(galleryItem).find('.gallery-container');
    galleryContainer.addClass(`gallery-container-${index}`);

    const swiper = new Swiper(`.gallery-container-${index}`, {
        modules: [Navigation, Pagination],
        a11y:true,
        speed: 400,
        spaceBetween: 100,
        loop: true,
        centeredSlides: false,
        // breakpointBase: 'window',
        slidesPerView: 1,
        // slideClass: 'gallery-item',
        navigation: {
            addIcons: false,
            nextEl: `.photo-gallery-${index} .swiper-button-next`,
            prevEl: `.photo-gallery-${index} .swiper-button-prev`,
        },
        // pagination: {
        //     el: `.gallery-container-${index} .swiper-pagination`,
        //     clickable: true,
        // },
    });
});


